<template>
  <div v-if="showModal" class="modalOpenned" style="top:0;left:0;position:fixed;z-index:19000;">
    <div style="top:0;left:0;position:fixed;background-color:#000000;opacity:0.7;width:100vw;height:100vh;"></div>
      <div :style="{width: getWidth(), height:getHeight(), top: getTop(), left: getLeft()}"  class="modal_inn" style="max-width:100vw!important;max-height:100vh!important;border-radius:4px;position:fixed;z-index:19001;background-color:#ffffff;">
        <slot />
      </div>
  </div>
</template>

<script>
import colors from '@/mixins/colors'
export default {
  props: ['modalWidth', 'modalHeight', 'showModal'],
  data () {
    return {
        width: 300,
        height: 500,
        maxHeight: 500,
        maxWIdth: 300
    }
  },
  name: 'Modal',
  mixins: [colors],
  watch: {
    showModal: function (val) {
      if (val) {
        document.getElementsByTagName('body')[0].style.overflow = 'hidden'
        document.getElementsByTagName('body')[0].style.webkitOverflowScrolling = 'hidden';
      } else {
        document.getElementsByTagName('body')[0].style.overflow = 'scroll'
        document.getElementsByTagName('body')[0].style.webkitOverflowScrolling = 'touch';
      }
    }
  },
  mounted () {
    if (this.$props.modalWidth) {
      this.width = this.$props.modalWidth
    }
    if (this.$props.modalHeight) {
      this.height = this.$props.modalHeight
      this.maxHeight = this.$props.modalHeight
    }
    if (this.$props.showModal) {
      document.getElementsByTagName('body')[0].style.overflow = 'hidden'
      document.getElementsByTagName('body')[0].style.webkitOverflowScrolling = 'hidden';
    } else {
      document.getElementsByTagName('body')[0].style.overflow = 'scroll'
      document.getElementsByTagName('body')[0].style.webkitOverflowScrolling = 'touch';
    }
  },

  methods: {
    getWidth () {
      return this.width + 'px'
    },
    getHeight () {
      return this.height + 'px'
    },
    getLeft () {
      if (this.width > window.innerWidth) {
        return 0
      } else {
        return 'calc( 50vw - ' + (this.width/2) + 'px)'
      }
    },
    getTop() {
      if (this.height > window.innerHeight){
        return 0
      } else {
        return 'calc( 50vh - ' + (this.height/2) + 'px)'
      }
    }
  }


}
</script>

<style lang="scss" scoped>

.modal_inn {
  -webkit-box-shadow:1px 2px 3px rgba(0, 0, 0, 0.5);
  -moz-box-shadow:1px 2px 3px rgba(0, 0, 0, 0.5);
  box-shadow:1px 2px 3px rgba(0, 0, 0, 0.5);
}

</style>
